import { render, staticRenderFns } from "./AddTestBooking.vue?vue&type=template&id=57f9386f&scoped=true"
import script from "./AddTestBooking.vue?vue&type=script&lang=js"
export * from "./AddTestBooking.vue?vue&type=script&lang=js"
import style0 from "./AddTestBooking.vue?vue&type=style&index=0&id=57f9386f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../Vue/course_selecttion_v3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f9386f",
  null
  
)

export default component.exports